import { MultiFactorAuthenticationError } from '@pba/client-auth';
import { useEffect } from 'react';
import { Loading, handleAxiosError } from 'ui';
import { getRailsAccessToken } from 'common/services';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useLoginToNode, useLoginWithTokenQuery } from 'features/users/queries';
import { useAuthenticateMutation, useHandleMfaError } from '../hooks';

type P = {
  loginToken: string;
  onNavigateToCheckCode: ({ tokenToGetCode, tokenToLogin }: { tokenToGetCode?: string; tokenToLogin?: string }) => void;
  onSuccessLogin: () => Promise<void>;
};

const TokenLogin = ({ loginToken, onNavigateToCheckCode, onSuccessLogin }: P) => {
  const { mutateAsync: checkTokenValidation } = useLoginWithTokenQuery();
  const { mutateAsync: nodeLoginAsync } = useLoginToNode();
  const { mutate: authenticate } = useAuthenticateMutation();

  const { contextHolder, handleError: handleMfaError } = useHandleMfaError({ onNavigateToCheckCode, onSuccessLogin });

  useEffect(() => {
    authenticate(
      {
        // TODO: use here login according to new strategy
        async nodeLogin() {
          const railsToken = await getRailsAccessToken();
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- Token will be always defined
          return nodeLoginAsync({ accessToken: railsToken!, strategy: 'pba' });
        },
        async railsLogin() {
          return checkTokenValidation({ token: loginToken });
        },
      },
      {
        onError(error) {
          if (error instanceof MultiFactorAuthenticationError) {
            handleMfaError({ error });
          } else {
            handleAxiosError(error);
          }
        },
        async onSuccess() {
          await onSuccessLogin();
        },
      },
    );
  }, [authenticate, checkTokenValidation, handleMfaError, loginToken, nodeLoginAsync, onSuccessLogin]);

  return (
    <>
      {contextHolder}
      <Loading viewportHeight />
    </>
  );
};

export default TokenLogin;
